import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { UseLoadingAction } from "@/common/composition/loading";
import { ScanSession } from "@/views/customize/data-sources/data/model";
import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
import * as api from "./api";
import { Ref, computed, ref } from "@vue/composition-api";
import { ICONS } from "@/common/icons.map";
import { UserSettings } from "@/common/api/user-settings.api";
import { SharedState } from "@/common/state";

const MSAtRestLabelsSettings = UserSettings.key<string[]>(
  "overview_msft_365",
  () => SharedState.l0_known_content_info_types.value.map((d) => d.id)
);

const [loading, set_loading] = UseLoadingAction<
  "init" | "change_session" | "change_labels"
>(false, "init");

const [
  sessions,
  selected_session,
  _set_selected_session,
  init_sessions,
] = UseDropdownItems<ScanSession>([]);

const selected_labels: Ref<string[]> = ref([]);
const selected_labels_count = computed(() => selected_labels.value.length);
const save_selected_labels_ids = async (ids: string[]) => {
  selected_labels.value = ids;
  set_loading(true, "change_labels");
  await load_items();
  await MSAtRestLabelsSettings.update(ids);
  set_loading(false, "change_labels");
};

const set_selected_session = async (session: ScanSession) => {
  // @ts-ignore
  _set_selected_session(session);
  set_loading(true, "change_session");
  await load_items();
  set_loading(false, "change_session");
};

const display_items = ref([
  {
    id: "msft_teams",
    name: "Teams",
    items: [],
    icon: ICONS.APPLICATIONS.get("msft_teams"),
  },
  {
    id: "msft_onedrive",
    name: "OneDrive",
    items: [],
    icon: ICONS.APPLICATIONS.get("msft_onedrive"),
  },
  {
    id: "msft_sharepoint_365",
    name: "SharePoint",
    items: [],
    icon: ICONS.APPLICATIONS.get("msft_sharepoint_365"),
  },
]);

const get_teams_items = api.get_sensitive_data_count_for_app("msft_teams");
const get_onedrive_items = api.get_sensitive_data_count_for_app(
  "msft_onedrive"
);
const get_sharepoint_items = api.get_sensitive_data_count_for_app(
  "msft_sharepoint_365"
);

const load_items = async () => {
  const session_id = +selected_session.value!.id;
  const res = await Promise.all([
    get_teams_items(selected_labels.value, session_id),
    get_onedrive_items(selected_labels.value, session_id),
    get_sharepoint_items(selected_labels.value, session_id),
  ]);
  if (res.every((d) => d.success)) {
    // @ts-ignore
    display_items.value[0].items = res[0].value;
    // @ts-ignore
    display_items.value[1].items = res[1].value;
    // @ts-ignore
    display_items.value[2].items = res[2].value;
  }
};

const init = async (force = false) => {
  set_loading(true, "init");
  selected_labels.value = await MSAtRestLabelsSettings.get();
  selected_labels.value = selected_labels.value.filter(
    (id) => SharedState.allInfoTypes.value[id]
  );
  selected_labels.value = selected_labels.value.filter(
    (id) => SharedState.allInfoTypes.value[id]
  );
  console.log("selected_labels.value ::", selected_labels.value);
  await data_sources_state.init();
  const res = await data_sources_state.ext.get_sessions_for_source("msft_365");
  if (res.success) {
    init_sessions(res.value);
    if (sessions.value.length > 0) {
      if (force) {
        set_selected_session(sessions.value[0]);
      } else {
        set_selected_session(selected_session.value || sessions.value[0]);
      }
    }
  }
  set_loading(false, "init");
};

export const state = {
  init,
  loading,
  sessions,
  display_items,
  set_selected_session,
  selected_session,
  // labels
  selected_labels_count,
  selected_labels,
  save_selected_labels_ids,
};
